module.exports = __webpack_public_path__ + "img/diente84.167e7d06.png";